var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"j-end"},[_c('btn-excel',{attrs:{"apertura_caja":_vm.apertura_caja}}),_c('btn-reabrir',{attrs:{"apertura_caja":_vm.apertura_caja}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }